import FullStoryService from './full-story-service';

export default FullStoryService;
